import { render, staticRenderFns } from "./SearchBlockedPhrase.vue?vue&type=template&id=1ec5f85c&lang=html"
import script from "./SearchBlockedPhrase.vue?vue&type=script&lang=js"
export * from "./SearchBlockedPhrase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports